import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./datastrategyaboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const DataStrategyAboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                    <a href="https://event.on24.com/wcc/r/2542620/4B6065954EB1685882AB3E22C711CDDD" target="_blank" className="pinkify">Watch the On-Demand session</a> from SNG Live: Data Strategy. We had a great session with federal IT leaders who discussed best practices and the progress they’re making around the new data policies. <br /><br />
 
 Ted Kaouk, the CDO at USDA and the head of the Federal CDO Council, joined Daniel Prieto, Google Cloud’s Strategic Executive for Federal Government, to discuss insights around the 2020 Federal Data Strategy and the evolving role of the CDO.<br /><br />
  
 Eileen Vidrine, CDO of the U.S. Air Force, Dr. Portia Crowe, CDO of the Network Cross Functional Team within Army Futures Command, and Shaun Bierweiler, President of Cloudera, talked about the critical role data plays in the defense world. <br /><br />
  
 The session closed with a conversation about why data is the most strategic asset, featuring NSF CDO Dorothy Aronson; Justin Marsico, the CDO and Deputy Assistant Commissioner for the Bureau of the Fiscal Service at the Treasury Department; and Alan Lawrence, Boomi’s Vice President of Federal.
                    </p>
                        
                        <p>
                        <a className="regmobwatch" href="https://event.on24.com/wcc/r/2542620/4B6065954EB1685882AB3E22C711CDDD" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/wcc/r/2542620/4B6065954EB1685882AB3E22C711CDDD" target="_blank">WATCH NOW »</a>
                        
                    </div>
                    
                    
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "aug")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                       
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "aug")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default DataStrategyAboutWrap